export default __webpack_public_path__ + "static/pure-love-4a2749b2f24eeeb066d19c29b2be9bcd.png";